import callState from '../../store/call';
import { get } from 'svelte/store';
import { IDLE, INCALL, OUTCALL, OUTGOING, RINGING } from '../../common/callState';
import pubsub from 'sweet-pubsub';
import toast from '../../services/toast';
const startTimer = () => {
    const interval = setInterval(() => {
        const { duration } = get(callState);
        // checkForTermination(r)
        callState.update({
            duration: duration + 1
        });
    }, 1000);
    callState.update({
        timerInterval: interval
    });
};
const stopTimer = () => {
    const { duration, timerInterval } = get(callState);
    if (timerInterval && duration !== 0) {
        clearInterval(timerInterval);
        callState.update({
            duration: 0,
            timerInterval: null
        });
    }
};
export const connect = async () => {
    const { domain, host, port, protocol, username, password } = get(callState).credentials;
    // const domain = "stagingbqlv3e20.staging.pbx.pressone.co"
    // const host = "stagingbqlv3e20.staging.pbx.pressone.co"
    // const port = 7443
    // const protocol = "wss"
    // const username = "999"
    // const password = "AC0RRcV0ZdD6davLwnUnbn9tYOM="
    const socket = new JsSIP.WebSocketInterface(`${protocol}://${host}:${port}/${protocol}`);
    socket['via_transport'] = 'WSS';
    const configuration = {
        sockets: [socket],
        uri: `sip:${username}@${domain}`,
        password,
        session_timers: true,
        use_preloaded_route: false,
    };
    const ua = new JsSIP.UA(configuration);
    ua.on('connected', () => {
        callState.update({
            sip_connected: true
        });
    });
    ua.on('disconnected', () => {
        callState.update({
            sip_connected: false
        });
    });
    ua.on('newRTCSession', (data) => {
        const callSession = data.session;
        const { peer, notes, duration, state } = get(callState);
        const remoteAudio = document.querySelector("audio");
        if (!remoteAudio) {
            throw new Error("No audio element present. Specify a <audio /> tag any where in your file");
        }
        callSession.on('ended', async () => {
            console.log("ended");
            // when the call is ended
            callState.update({
                state: IDLE
            });
            stopTimer();
            let callDirection = callSession.direction;
            let direction = callDirection === 'incoming' ? 'Inbound' : 'Outbound';
            pubsub.emit('call_ended', {
                direction,
                duration,
                peer,
                notes,
            });
        });
        callSession.on('failed', async (data) => {
            console.log("failed", data);
            // when the call is rejected by the other party or missed call
            toast.warn(`The call is ${data.cause}`); // toast notification
            let callDirection = callSession.direction;
            let direction = duration === 0 && callDirection === 'incoming'
                ? 'Missed'
                : callDirection === 'incoming'
                    ? 'Inbound'
                    : 'Outbound';
            pubsub.emit('call_ended', {
                direction,
                duration,
                peer,
                notes,
            });
            stopTimer();
            callState.reset();
        });
        callSession.on('confirmed', () => {
            console.log("confirmed");
            callState.update({
                state: callSession.direction === 'incoming' ? INCALL : OUTCALL
            });
            startTimer();
            pubsub.emit('call_started', {
                direction: callSession.direction === 'incoming' ? 'Inbound' : 'Outbound',
                peer,
            });
        });
        if (state === IDLE) {
            const peer = callSession.remote_identity.display_name ||
                callSession.remote_identity._uri._user;
            callState.update({
                callSession,
                peer,
                state: callSession.direction === 'incoming' ? RINGING : OUTGOING,
                duration: 0,
                notes: '',
            });
            if (callSession.direction === 'incoming') {
                pubsub.emit('call_ringing', {
                    peer,
                });
            }
        }
        switch (callSession.direction) {
            case 'outgoing':
                callSession.connection.addEventListener('addstream', (e) => {
                    remoteAudio.srcObject = e.stream;
                    setTimeout(() => {
                        remoteAudio.play();
                    }, 500);
                });
                break;
            case 'incoming':
                callSession.on('peerconnection', (data) => {
                    data.peerconnection.addEventListener('addstream', (e) => {
                        remoteAudio.srcObject = e.stream;
                        setTimeout(() => {
                            remoteAudio.play();
                        }, 500);
                    });
                });
                break;
        }
        if (callSession.direction === 'incoming' &&
            (state === IDLE || state === RINGING)) {
            callState.update({
                incoming_call_active: true
            });
        }
    });
    ua.start();
    callState.update({
        ua
    });
};
export const initiateCall = (number, _options) => {
    const { sessions = [], ua, state } = get(callState);
    let options = {
        mediaConstraints: { audio: true, video: false },
        pcConfig: {
            rtcpMuxPolicy: 'negotiate',
            iceServers: [{ urls: ['stun:stun.l.google.com:19302'] }],
        },
        sessionTimersExpires: 1800
    };
    if (_options) {
        options = Object.assign(Object.assign({}, options), _options);
    }
    if (state === IDLE) {
        const call_session = ua.call(number, options);
        setTimeout(() => {
            sessions.push(call_session);
            callState.update({
                sessions,
                call_active: true
            });
        }, 500);
    }
};
